import AudienceMetadata from './AudienceMetadata'
export default AudienceMetadata
